export const actions = {
  setCarrierCredentials({ commit }, payload) {
    commit("SET_CARRIER_CREDENTIALS", payload);
  },
};
